<template>
    <div :class="$style.wrapper">
        <div>
            <img
                :src="NoAdsImg"
                :class="$style.order_icon"
            />
            <Typography
                is="div"
                type="header"
                size="s"
            >
                {{ $tr('disabledAd.title') }}
            </Typography>
            <Typography
                is="div"
                type="paragraph"
                size="xs"
                :class="$style.subtitle"
            >
                <!-- eslint-disable vue/no-v-html -->
                <span v-html="$tr('disabledAd.subtitle')" />
                <!-- eslint-enable vue/no-v-html -->
            </Typography>
        </div>
        <PurchaseInfo
            :title="$tr('disabledAd.duration', { duration: order.durationInDays.toString() })"
            :subtitle="$tr('disabledAd.priceInGam', { price: priceInGam.toString() })"
        />
        <Typography
            is="div"
            v-if="balance > 0 && showPayment"
            type="paragraph"
            size="xs"
            :class="$style.subtitle"
        >
            {{ $tr('paymentModal.paymentExplanation', { balance: balance.toString() }) }}
        </Typography>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import NoAdsImg from '@/components_new/ModalItems/images/no-ads.webp'
import Typography from '@/components_new/Typography.vue'
import { DisableAdOrder } from '@/modules/in-game-payments'
import { PRICE_IN_GAM } from '@/store/ad-disabled-store'

import PurchaseInfo from './PurchaseInfo.vue'

const props = defineProps<{
    order: DisableAdOrder
    balance: number
    showPayment: boolean
}>()

const priceInGam = computed(() => PRICE_IN_GAM[props.order.durationInDays])
</script>

<style module>
.order_icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
}

.subtitle {
    color: var(--white-60);
    margin-top: 4px;
}

@media (--desktop-small-plus) {
    .wrapper {
        min-width: 380px;
    }
}
</style>
